module.exports = __webpack_public_path__ + "img/prev.461a565f.svg";